{
  "auditLogs": {
    "title": "Journal d'audit",
    "description": "Afficher toutes les mutations de données des entités locataires",
    "timestamp": "Horodatage",
    "actor": "Acteur",
    "action": "Action",
    "entityType": "Type d'entité",
    "entityId": "ID d'entité",
    "summary": "Résumé",
    "scope": "Portée",
    "superadminScope": "Superadmin",
    "filterByThisActor": "Filtrer par cet acteur",
    "filterByThisEntity": "Filtrer par ce type d'entité",
    "filterByThisEntityId": "Filtrer par cet ID d'entité",
    "fieldChanges": "Changements de champs",
    "batchInfo": "Info du lot",
    "snapshot": "Instantané du document",
    "empty": "Aucun journal d'audit trouvé",
    "showing": "Affichage {{from}}-{{to}} sur {{total}}",
    "previous": "Précédent",
    "next": "Suivant",
    "systemActor": "Système",
    "ip": "IP",
    "endpoint": "Point de terminaison",
    "sessionId": "ID de session",
    "actionCreate": "Créer",
    "actionUpdate": "Mettre à jour",
    "actionSoftDelete": "Suppression douce",
    "actionDestroy": "Détruire",
    "actionBulkSoftDelete": "Suppression douce en masse",
    "actionBulkDestroy": "Destruction en masse",
    "actionBulkWrite": "Écriture en masse",
    "field": "Champ",
    "from": "De",
    "to": "À",
    "batchFilter": "Filtre",
    "batchUpdate": "Mise à jour",
    "batchMatched": "Correspondants",
    "batchModified": "Modifiés",
    "noDetails": "Aucun détail disponible",
    "fieldsChanged": "{{count}} champ(s) modifié(s)",
    "matchedModified": "{{matched}} correspondants, {{modified}} modifiés",
    "snapshotCaptured": "Instantané capturé"
  },
  "tenantAdmin": {
    "title": "Locataires",
    "description": "Gérer tous les locataires du système",
    "createTenant": "Créer un locataire",
    "editTenant": "Modifier le locataire",
    "updateTenant": "Mettre à jour le locataire",
    "createDescription": "Ajouter un nouveau locataire au système",
    "cloneTenant": "Dupliquer le locataire",
    "cloneDescription": "Créer une copie indépendante de {{name}}, incluant toutes ses données.",
    "cloneNameDefault": "Copie de {{name}}",
    "cloneWarningTitle": "Les utilisateurs sont copiés",
    "cloneWarning": "Le clone copie tous les utilisateurs avec leurs identifiants existants. Chaque utilisateur peut se connecter aux deux locataires avec le même e-mail et le même mot de passe.",
    "cloneStarted": "La duplication s'exécute en arrière-plan. Le nouveau locataire devient actif dès qu'elle est terminée.",
    "cloneRunningBadge": "création en cours…",
    "cloneRunningTooltip": "Duplication en arrière-plan : {{phase}}",
    "clonePhaseCopying": "copie des données",
    "clonePhaseProvisioning": "création des accès",
    "clonePhaseImporting": "importation des accès de démo",
    "cloneInterruptedBadge": "Duplication interrompue",
    "cloneFailedBadge": "Duplication échouée",
    "cloneImportFailedBadge": "Identifiants de démo manquants",
    "cloneImportFailed": "Le locataire a été dupliqué et est prêt, mais les identifiants de démonstration n'ont pas pu être créés. Personne ne pourra s'y connecter tant que l'import n'aura pas été relancé.",
    "cloneCompletedBadge": "Avis restant",
    "cloneCompleted": "La duplication est terminée et le locataire est prêt. Seul cet avis n'a pas pu être supprimé automatiquement — vous pouvez le masquer sans risque.",
    "cloneInterruptedAlertTitle": "La duplication de {{name}} a été interrompue",
    "cloneInterruptedAlert": "La duplication a été interrompue et ne s'est jamais terminée. Rien n'a été supprimé : le locataire incomplet ({{slug}}) existe toujours et est inactif. « Abandonner et supprimer » le supprime avec sa base de données et ses adhésions, « Ignorer » le conserve et masque uniquement cet avis.",
    "cloneFailedAlertTitle": "La duplication de {{name}} a échoué",
    "cloneFailedAlert": "La duplication a échoué et a été annulée. Ce qui subsiste du locataire incomplet ({{slug}}) est inactif. « Abandonner et supprimer » retire les restes ainsi que sa base de données et ses adhésions, « Ignorer » les conserve et masque uniquement cet avis.",
    "cloneDiscardPartialAlertTitle": "L'abandon de {{name}} est incomplet",
    "cloneDiscardPartialAlert": "Un abandon a déjà été exécuté et n'a réussi que partiellement. Échecs : {{steps}}. Tout le reste a été supprimé.",
    "cloneDiscardPartialRetry": "Le locataire et sa base de données sont toujours présents — vous pouvez relancer l'abandon.",
    "cloneDiscardPartialManual": "Le locataire et sa base de données ont déjà été supprimés ; les éléments restants ci-dessus doivent être nettoyés manuellement. « Ignorer » masque uniquement cet avis.",
    "cloneCleanupStepRevokeMemberships": "révocation des adhésions",
    "cloneCleanupStepDeactivateZitadelOrg": "désactivation de l'organisation Zitadel",
    "cloneCleanupStepDropDatabase": "suppression de la base de données",
    "cloneCleanupStepDeleteTenantRow": "suppression de la fiche du locataire",
    "cloneDiscard": "Abandonner et supprimer",
    "cloneDismiss": "Ignorer",
    "cloneDiscardTitle": "Abandonner la copie incomplète",
    "cloneDiscardDescription": "Le locataire {{name}}, sa base de données et toutes les adhésions créées à cette occasion seront définitivement supprimés. Cette action est irréversible.",
    "cloneDiscardSuccess": "Copie incomplète abandonnée",
    "cloneDiscardPartial": "La copie n'a pu être supprimée que partiellement. L'avis reste affiché jusqu'à ce que les éléments restants soient nettoyés.",
    "cloneDismissSuccess": "Avis masqué",
    "cloneFailed": "Échec de la duplication du locataire",
    "editDescription": "Mettre à jour les informations du locataire",
    "searchPlaceholder": "Rechercher des locataires...",
    "tenantName": "Nom du locataire",
    "tenantNamePlaceholder": "Saisir le nom du locataire",
    "tenantNameRequired": "Le nom du locataire est requis",
    "tenantSlug": "Identifiant du locataire",
    "tenantSlugPlaceholder": "identifiant-locataire",
    "tenantSlugRequired": "L'identifiant du locataire est requis",
    "tenantSlugPattern": "L'identifiant doit contenir uniquement des lettres minuscules, des chiffres et des tirets",
    "tenantSlugHelper": "Identifiant compatible URL (généré automatiquement à partir du nom)",
    "tenantType": "Type de locataire",
    "tenantTypePlaceholder": "Sélectionner le type de locataire",
    "tenantTypeCustomer": "Client",
    "tenantTypePartner": "Partenaire",
    "expirationDate": "Date d'expiration",
    "expirationHelper": "Laisser vide pour aucune expiration",
    "cancel": "Annuler",
    "createFailed": "Échec de la création du locataire",
    "updateFailed": "Échec de la mise à jour du locataire",
    "columnName": "Nom",
    "columnSlug": "Identifiant",
    "columnType": "Type",
    "columnAccount": "Compte",
    "accountLabel": "Compte : {{name}}",
    "noAccount": "Aucun compte",
    "columnStatus": "Statut",
    "columnExpires": "Expire",
    "columnMembers": "Membres",
    "columnProcesses": "Processus",
    "filterAll": "Tous",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "expiresNever": "Jamais",
    "hideExpired": "Masquer les expirés",
    "deleteSuccess": "Locataire supprimé avec succès",
    "deleteFailed": "Échec de la suppression du locataire",
    "deleteTitle": "Supprimer le locataire",
    "deleteDescription": "Êtes-vous sûr de vouloir supprimer ce locataire ? Cela supprimera également toutes les données associées. Cette action est irréversible.",
    "deleteConfirmInstruction": "Saisissez <strong /> pour confirmer la suppression.",
    "deleteConfirmPlaceholder": "Saisissez le nom du locataire pour confirmer",
    "cloneWarningDemoTitle": "Démo : de nouveaux identifiants sont créés",
    "cloneWarningDemo": "Le clone copie tous les utilisateurs, mais chaque e-mail est réécrit vers une nouvelle adresse de démo (p. ex. demo+jane.doe.12@bliks.io) et tous les utilisateurs reçoivent le mot de passe de démo défini ci-dessous. Les utilisateurs des démos précédentes n'ont pas accès à celle-ci.",
    "tenantTypeDemo": "Démo",
    "tenantDescription": "Remarque",
    "tenantDescriptionPlaceholder": "p. ex. Démo pour la société XYZ",
    "columnDescription": "Remarque",
    "demoPassword": "Mot de passe de démo",
    "demoPasswordRequired": "Mot de passe de démo requis : au moins 8 caractères avec une majuscule, une minuscule et un chiffre",
    "demoPasswordHint": "Mot de passe commun à tous les utilisateurs de cette démo. Au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.",
    "homeOrgLabel": "Organisation d'origine",
    "homeOrgNotSet": "Non défini",
    "homeOrgMoveWarningTitle": "Le compte de connexion sera recréé",
    "homeOrgMoveWarning": "Déplacer cet utilisateur vers une autre organisation d'origine recrée son compte de connexion. Le mot de passe, les passkeys et la MFA sont perdus, les sessions actives ne peuvent pas effectuer de vérification renforcée tant que la nouvelle invitation n'est pas complétée, et un nouvel e-mail d'invitation est envoyé.",
    "homeOrgNoTargets": "Cette personne n'est membre d'aucune organisation SSO pouvant être définie comme organisation d'origine.",
    "homeOrgDeletedBadge": "Organisation d'origine supprimée",
    "homeOrgDeletedTooltip": "L'organisation d'origine de cet utilisateur a été supprimée — la connexion est (ou sera) bloquée. Attribuez une nouvelle organisation d'origine pour rétablir l'accès.",
    "homeOrgDeletedAlertTitle": "Organisation d'origine supprimée — compte verrouillé",
    "homeOrgDeletedAlert": "L'organisation d'origine de cet utilisateur a été supprimée, sa connexion est donc (ou sera) bloquée. Sélectionnez une nouvelle organisation d'origine ci-dessous pour rétablir l'accès.",
    "homeOrgDeletedNoTargetsAlert": "L'organisation d'origine de cet utilisateur a été supprimée, sa connexion est donc (ou sera) bloquée. Aucune organisation cible éligible n'est disponible — accordez d'abord à l'utilisateur une adhésion à une organisation SSO, puis attribuez-la comme nouvelle organisation d'origine.",
    "hubspotCompanyId": "ID entreprise HubSpot",
    "hubspotCompanyIdPlaceholder": "p. ex. 340997605594",
    "hubspotPartnerCompanyIdHelper": "ID d'entreprise HubSpot de la société partenaire (type « Partner »).",
    "cloneSource": "Modèle",
    "cloneSourceHint": "Toutes les données sont copiées depuis cet espace de travail.",
    "cloneSourcePlaceholder": "Choisir un espace de travail",
    "cloneSourceRequired": "Veuillez choisir un espace de travail à copier",
    "createDemo": "Créer une démo",
    "createDemoDescription": "Une démo naît comme copie d'un espace de travail existant — elle en reprend le contenu, mais reçoit ses propres identifiants.",
    "hubspotCompanyIdHelper": "ID d’entreprise HubSpot de ce client. Relie l’entreprise HubSpot à ce tenant Bliks."
  },
  "recordingAnalytics": {
    "title": "Analyses d'enregistrement",
    "description": "Temps d'enregistrement actif moyen par processus, tous locataires confondus",
    "scope": "Locataire",
    "allTenants": "Tous les locataires",
    "empty": "Aucune donnée de temps d'enregistrement pour le moment",
    "tenant": "Locataire",
    "process": "Processus",
    "minutesSuffix": "{{value}} min",
    "avgPerStep": "Temps moyen par étape",
    "avgPerProcess": "Temps moyen par processus",
    "acrossSteps": "sur {{count}} enregistrements d'étape",
    "acrossProcesses": "sur {{count}} processus",
    "processCount": "Processus",
    "stepCount": "Étapes",
    "total": "Temps total",
    "step": "Étape",
    "stepTime": "Temps d'enregistrement"
  },
  "aiUsage": {
    "title": "Utilisation de l'IA",
    "description": "Coûts d'IA et consommation de jetons par locataire",
    "tenantTabDescription": "Coûts d'IA et consommation de jetons de ce locataire (toutes périodes), par source et modèle",
    "scope": "Locataire",
    "allTenants": "Tous les locataires",
    "range": "Période",
    "range7d": "7 derniers jours",
    "range30d": "30 derniers jours",
    "range90d": "90 derniers jours",
    "rangeAll": "Toute la période",
    "empty": "Aucune utilisation de l'IA enregistrée",
    "loadError": "Échec du chargement des données d'utilisation de l'IA",
    "tenant": "Locataire",
    "totalCost": "Coût total",
    "cost": "Coût",
    "calls": "Appels",
    "callsBreakdown": "{{generation}} générations · {{embedding}} embeddings · {{transcription}} transcriptions",
    "acrossCalls_one": "sur {{count}} appel",
    "acrossCalls_other": "sur {{count}} appels",
    "tokens": "Jetons",
    "tokensBreakdown": "{{input}} en entrée · {{output}} en sortie",
    "transcription": "Transcription",
    "minutesSuffix": "{{value}} min",
    "source": "Source",
    "unknownSource": "Source inconnue",
    "kind": "Type",
    "kindFeature": "Fonctionnalité",
    "kindApp": "Application",
    "model": "Modèle",
    "inputTokens": "Jetons en entrée",
    "outputTokens": "Jetons en sortie",
    "priceMissingEvents_one": "{{count}} appel sans entrée de prix, compté avec un coût de 0",
    "priceMissingEvents_other": "{{count}} appels sans entrée de prix, comptés avec un coût de 0",
    "priceMissingWarning_one": "{{count}} appel sans entrée de prix — les totaux de coûts sont sous-estimés",
    "priceMissingWarning_other": "{{count}} appels sans entrée de prix — les totaux de coûts sont sous-estimés",
    "failedTenantsWarning_one": "{{count}} locataire n'a pas pu être lu — les totaux sont incomplets",
    "failedTenantsWarning_other": "{{count}} locataires n'ont pas pu être lus — les totaux sont incomplets"
  },
  "partnerContent": {
    "title": "Contenus partenaires",
    "description": "Ce que voient tous les partenaires commerciaux : documents et vidéos de l’Info Hub et actualités de leur page d’accueil.",
    "tabs": {
      "materials": "Info Hub",
      "news": "Actualités"
    },
    "status": {
      "published": "Publié",
      "draft": "Brouillon"
    },
    "filter": {
      "all": "Tous"
    },
    "emptyFiltered": "Aucun élément ne correspond au filtre.",
    "columns": {
      "order": "Ordre",
      "title": "Titre",
      "status": "Statut",
      "languages": "Langues",
      "updatedAt": "Modifié",
      "publishedAt": "Publié le"
    },
    "actions": {
      "publish": "Publier",
      "unpublish": "Retirer",
      "saveDraft": "Enregistrer comme brouillon",
      "undo": "Annuler",
      "moveUp": "Monter",
      "moveDown": "Descendre"
    },
    "toast": {
      "published": "Publié. Les partenaires le voient maintenant.",
      "saved": "Enregistré comme brouillon.",
      "saveFailed": "L’enregistrement a échoué. Veuillez réessayer."
    },
    "completeness": {
      "complete": "complet",
      "partial": "incomplet",
      "empty": "manquant"
    },
    "languages": {
      "title": "Langues",
      "contentTitle": "Contenu par langue",
      "hint": "L’allemand est obligatoire. Si une langue manque, les partenaires voient la version anglaise, sinon l’allemande.",
      "present": "{{language}} disponible",
      "missing": "{{language}} manquant"
    },
    "fields": {
      "titleIn": "Titre ({{language}})",
      "descriptionIn": "Description ({{language}})"
    },
    "materials": {
      "add": "Ajouter un document",
      "createTitle": "Nouveau document",
      "editTitle": "Modifier le document",
      "dialogDescription": "Apparaît dans l’Info Hub de tous les partenaires une fois publié.",
      "general": "Général",
      "kind": "Type",
      "kinds": {
        "file": "Fichier",
        "video": "Vidéo"
      },
      "kindHints": {
        "file": "PDF, PowerPoint, Word ou Excel, un fichier par langue",
        "video": "Une vidéo YouTube"
      },
      "videoUrl": "Lien YouTube",
      "videoPreview": "Miniature de la vidéo",
      "needsFile": "Un document a besoin d’au moins un fichier pour être publié.",
      "empty": "Aucun document pour le moment. Ajoutez le premier.",
      "loadError": "Les documents n’ont pas pu être chargés.",
      "deleteEntityPhrase": "ce document et ses fichiers",
      "files": {
        "label": "Fichier",
        "dropTitle": "Déposez ici le fichier en {{language}}",
        "dropHint": "PDF, PowerPoint, Word ou Excel, jusqu’à 25 Mo",
        "choose": "Choisir le fichier en {{language}}",
        "replace": "Remplacer",
        "remove": "Supprimer le fichier en {{language}}",
        "uploadOnSave": "téléversé à l’enregistrement",
        "removedOnSave": "{{name}} sera supprimé à l’enregistrement.",
        "rejected": {
          "format": "Formats autorisés : PDF, PowerPoint, Word et Excel.",
          "size": "Le fichier dépasse 25 Mo."
        }
      }
    },
    "news": {
      "add": "Rédiger une actualité",
      "createTitle": "Nouvelle actualité",
      "editTitle": "Modifier l’actualité",
      "dialogDescription": "Apparaît sur la page d’accueil des partenaires une fois publiée ; le public décide lesquels.",
      "general": "Général",
      "pinned": "Afficher en premier",
      "pin": "Afficher en premier",
      "unpin": "Ne plus afficher en premier",
      "bodyIn": "Texte ({{language}})",
      "preview": "Aperçu",
      "previewHint": "Ce que voient les partenaires en {{language}}.",
      "empty": "Aucune actualité pour le moment. Rédigez la première.",
      "loadError": "Les actualités n’ont pas pu être chargées.",
      "deleteEntityPhrase": "cette actualité",
      "eyebrow": "Surtitre",
      "eyebrowIn": "Surtitre ({{language}})",
      "footnoteIn": "Note de bas ({{language}})",
      "links": "Boutons",
      "primaryAction": "Bouton principal",
      "secondaryAction": "Bouton secondaire",
      "actionLabelIn": "Libellé du {{action}} ({{language}})",
      "images": {
        "title": "Images",
        "logo": "Logo",
        "logoHint": "Affiché en haut, p. ex. OMR et G2 dans une seule image. PNG, JPG, WebP ou SVG, jusqu’à 2 Mo.",
        "image": "Image",
        "imageHint": "Affichée en carré à côté du texte. PNG, JPG, WebP ou SVG, jusqu’à 2 Mo.",
        "choose": "Choisir : {{label}}",
        "remove": "Supprimer : {{label}}",
        "rejected": {
          "format": "Formats autorisés : PNG, JPG, WebP et SVG.",
          "size": "L’image dépasse 2 Mo."
        }
      },
      "audience": "Public",
      "audienceHint": "Tous les partenaires, ou seulement ceux qui utilisent l’application de vente.",
      "audienceAll": "Tous les partenaires",
      "audienceSales": "Utilisateurs de l’app de vente"
    }
  },
  "accountAdmin": {
    "addAccount": "Créer un compte",
    "addAccountHint": "Rechercher l'entreprise qui devient le client — c'est l'identifiant HubSpot qui est associé.",
    "addTenant": "Créer un espace de travail",
    "assignCompany": "Associer une entreprise",
    "assignCompanyHint": "Rechercher par nom ou domaine — c'est toujours l'identifiant HubSpot qui est associé, jamais le nom.",
    "backToAccounts": "Retour aux comptes",
    "changeCompany": "Changer d'entreprise",
    "childCount": "{{count}} en dessous",
    "children": "Comptes enfants",
    "columnGroup": "Groupe",
    "columnName": "Client",
    "columnTenants": "Espaces de travail",
    "companiesUnavailable": "Les noms d'entreprise n'ont pas pu être chargés depuis HubSpot — les comptes sont complets, seuls les noms manquent.",
    "company": {
      "ambiguous": {
        "primary": "Plusieurs contacts portent l'étiquette de contact principal. Le premier l'emporte — veuillez clarifier dans le CRM.",
        "billing": "Plusieurs contacts portent l'étiquette de facturation. Le premier l'emporte — veuillez clarifier dans le CRM."
      },
      "billingContactRole": "Facture",
      "contactUnnamed": "Contact sans nom",
      "heading": "Société dans le CRM",
      "noAddress": "Aucune adresse renseignée dans le CRM",
      "noBillingContact": "Aucun contact de facturation signalé dans le CRM",
      "noBillingEmail": "Aucun destinataire de facture renseigné",
      "noContact": "Aucun interlocuteur principal signalé dans le CRM",
      "noVatId": "Aucun numéro de TVA renseigné",
      "primaryContactRole": "Offre",
      "refresh": "Actualiser depuis HubSpot",
      "refreshChanged": "Données reprises de HubSpot.",
      "refreshUnchanged": "HubSpot lu — rien de nouveau.",
      "refreshUnread": "HubSpot n'a pas pu être lu. Le dernier état connu reste valable.",
      "unknownName": "Nom inconnu",
      "unlinked": "Aucune société liée pour le moment",
      "vatConfirmed": "confirmé",
      "vatRejected": "non confirmé",
      "vatUnchecked": "non vérifié"
    },
    "companyTaken": "Déjà associée",
    "createCompany": "Créer « {{name}} » dans HubSpot",
    "createWithoutCompany": "Créer sans entreprise",
    "description": "Les clients — un compte par entité juridique, pouvant gérer plusieurs espaces de travail.",
    "detachParent": "Détacher",
    "empty": "Aucun compte pour le moment.",
    "group": "Groupe",
    "groupHint": "Les comptes peuvent être regroupés sous une entité — groupe, chaîne, réseau. La relation n'accorde rien en soi : aucune lecture entre membres, aucune licence partagée, aucun moyen de paiement hérité.",
    "noChildren": "Aucun compte ne dépend de celui-ci.",
    "noCompany": "Aucune entreprise HubSpot enregistrée",
    "noParent": "Ne fait partie d'aucun groupe",
    "notFound": "Compte introuvable.",
    "openIn": "Ouvrir dans {{system}}",
    "parent": "Compte parent",
    "partOf": "Fait partie de",
    "saved": "Enregistré.",
    "searchCompanyEmpty": "Aucune entreprise trouvée.",
    "searchCompanyMin": "Saisissez au moins trois caractères.",
    "searchCompanyPlaceholder": "Nom ou domaine …",
    "searching": "Recherche …",
    "tenants": "Espaces de travail",
    "title": "Comptes",
    "unnamed": "Sans nom"
  }
}
